import React, { useState, useEffect, useRef } from "react";
import { VideoIframe, ChatSidebar, ChatMessenger } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import debounce from "lodash/debounce";
import { Alert, alertService } from "@hedgefund/shared/src/Alert/index";
import { HubConnectionBuilder } from "@microsoft/signalr";
import {
  getRooms,
  uploadFiles,
  getMessages,
  getArchiveMessages,
  updateArchiveMessage,
  seenMessages,
} from "./action";
import {
  ACTIVE_ROOM_UPDATE,
  ADD_SINGLE_MESSAGES,
  EMPTY_MESSAGES,
} from "./constants";
import jwt_decode from "jwt-decode";
import { Col, Row } from "antd/es/grid";

const Chat = () => {
  const messagePayload = useSelector((state) => state.chat);
  const { messageResult, loading, archiveRooms, rooms, activeRoom, mesLoading, roomLoading  } = messagePayload;
  const dispatch = useDispatch();
  const conversationSectionRef = useRef();
  const [connection, setConnection] = useState();
  const [isChatToggle, setIsChatToggle] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [archiveMode, setArchiveMode] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  // const identifier = queryParams.get("identifier");
  const type = queryParams.get("type");

  var token = sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const getUserDetails = () => {
    if (token !== null) {
      return jwt_decode(token);
    }
    return getUserDetails();
  };

  const getPagedMessages = debounce((page, pageSize, roomId) => {
    dispatch(
      getMessages({
        pageCount: page + 1,
        pageSize: pageSize,
        roomId: roomId,
      })
    );
  }, 900);

  const MessagesScroll = debounce((e) => {
    const { scrollTop } =
      conversationSectionRef.current;

    if (
      scrollTop <= 10 &&
      !loading &&
      !mesLoading &&
      messageResult.totalRows > messageResult.page * messageResult.pageSize
    ) {
      getPagedMessages(
        messageResult?.page,
        messageResult?.pageSize,
        activeRoom
      );
    }
  }, 900);
  const user = getUserDetails();
  useEffect(() => {
    const conRef = conversationSectionRef.current;
    if (conversationSectionRef && conRef) {
      conRef.addEventListener("scroll", MessagesScroll, false);
    }
    return ()=> conRef?.removeEventListener("scroll", MessagesScroll);
  }, [messageResult]);

  useEffect(() => {
    dispatch(getRooms(type ?? 1));
  }, []);

  const onRoomClick = async (roomId) => {
    
    dispatch({ type: EMPTY_MESSAGES });
    const room = rooms.find((r) => r.id === roomId);
    setSelectedRoom(room)
    if (room) {
      dispatch(seenMessages({ roomId: room.id, userId: user.UserId }));
      dispatch({ type: ACTIVE_ROOM_UPDATE, payload: room.id });

      getPagedMessages(
        0,
        10,
        room.id
      );
    }
  };

  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl(`${window._env_.CHAT_URL}?access_token=${token}`)
      .withAutomaticReconnect()
      .build();

    setConnection(connect);
    connect.onclose = connectToHub();
  }, []);

  var connectToHub = () => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection.on("ReceiveMessage", (message) => {
            dispatch({ type: ADD_SINGLE_MESSAGES, message });
          });

          connection.on("ExceptionMessage", (message) => {
            alertService.error(message, { autoClose: true });
          });
        })
        .catch((error) => console.log(error));
    }
  };
  useEffect(() => {
    if (connection) {
      connectToHub();
    }
  }, [connection]);

  const UpdateMessageSeen = () => {
    dispatch(seenMessages({ roomId: activeRoom, userId: user.UserId }));
  }
  const uploadFilesMessage = (payload) => {
    payload.append("UserId", user.sub);
    payload.append("RoomId", activeRoom);
    dispatch(uploadFiles(payload));
  };

  const sendMessage = async (message) => {
    var data = { type : "" , tenantId : ""};
    if (selectedRoom?.roomUsers === null) {
      var tenants = selectedRoom?.roomTenants?.find(x => x.tenantId !== user?.["http://www.aspnetboilerplate.com/identity/claims/tenantId"])
      data = {
        type : "Group",
        tenantId : tenants.tenantId
      }
    } else {
      var users = selectedRoom?.roomUsers?.find(x => x?.userId !== user.UserId)
      data = {
        type : "Private",
        tenantId : users.userId,
      }
    }
    try {
      let messageBody = {
        Message: message,
        UserName: user?.FullName,
        UserId: user?.sub,
        RoomId: activeRoom,
        tenantId: data.tenantId,
        type : data.type
      };
      await connection.invoke("SendMessageCustom", messageBody);
    } catch (e) {
      console.log(e);
    }
  };

  const onArchive = (isArchive, room) => {
    dispatch(updateArchiveMessage({ roomId: room.id, archive: isArchive }));
  };
  const onClickChatTab = (type) => {
      dispatch(getRooms(type));
  };

  const onClickArchiveTab = () => {
    dispatch(getArchiveMessages());
  };

  return (
    <main>
      <Alert />
      <div className="main-inner">
        <div className="p-4">
          <div className="main-content-header">
            {/* <h4 className="mb-0">{activeRoomName}</h4> */}
          </div>
          <div
            className="
            chat-container
            bg-white
            border
            overflow-hidden
            box-shadow
            mb-xxl-5 mb-4
          "
          >
            {/* <div className="chat-header text-center p-4">
              <h5 className="mb-0 text-blue">Chat Messenger</h5>
            </div> */}
            {/* <div className="chat-row"> */}
            <Row>
              <Col span={6}>
              <ChatSidebar
                isAllocator={false}
                getMessages={(room) => onRoomClick(room)}
                updateArchive={(isArchive, room) => onArchive(isArchive, room)}
                activeRoom={activeRoom}
                archiveRooms={archiveRooms}
                rooms={rooms}
                setArchiveMode={setArchiveMode}
                onClickArchiveTab={onClickArchiveTab}
                setIsChatToggle={setIsChatToggle}
                loading={roomLoading}
                archiveMode={archiveMode}
                onClickChatTab={onClickChatTab}
              />
              </Col>
              <Col span={18}>
              <ChatMessenger
                messageResult={messageResult?.items}
                sendMessage={sendMessage}
                uploadFiles={uploadFilesMessage}
                loading={mesLoading}
                userId={user.sub}
                user={user}
                conversationSectionRef={conversationSectionRef}
                isChatToggle={archiveMode}
                selectedRoom={selectedRoom}
                UpdateMessageSeen={UpdateMessageSeen}
                isHedgeFund = {true}
              />
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className="">
        <VideoIframe
          messageResult={messageResult?.items && messageResult?.items}
        />
      </div>
    </main>
  );
};

export default Chat;
